import { UseQueryResult } from '@tanstack/react-query'
import {
  MomentUsableCouponCountRes,
  getMomentUsableCouponCount,
} from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai/index'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  useErrorBoundary?: boolean
}

function useGetMomentUsableCouponCount(
  props: Props
): UseQueryResult<MomentUsableCouponCountRes, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)
  return useQueryWrapper<MomentUsableCouponCountRes, AxiosError>(
    KEYS.USER_COUPON(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<MomentUsableCouponCountRes>(
          '/ads/moment/usableCouponCount'
        )
        return data
      } else {
        const { data } = await getMomentUsableCouponCount()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetMomentUsableCouponCount }
